import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Message } from "primereact/message";
import { Captcha } from "primereact/captcha";
import { Growl } from 'primereact/growl';

import servicioObjetos from '../../servicio/ServicioObjetos';
import servicioHttp from '../../servicio/ServicioHttp';

export class RecuperaContrasena extends Component {
    constructor() {
        super();
        this.state = {
            usuario: {},
            errores: {},
            mostralModal: false,
            verificaCapchap: false
        };
    }

    recuperarContrasena = () => {
        let { usuario, tokenCaptcha } = this.state;
        const validacion = this.validarFormulario(usuario);
        this.setState({ errores: validacion });

        if (servicioObjetos.esObjetoVacio(validacion)) {
            let usuarioCopia = JSON.parse(JSON.stringify(usuario));
            usuarioCopia.token = tokenCaptcha;
            usuarioCopia.navegador = navigator.userAgent;
            servicioHttp
                .consumirPostHttp("/usuario/contrasena/recuperar.json", usuarioCopia)
                .then(response => {
                    if (response.data.error) {
                        this.expireCaptcha();
                        this.growl.show({ severity: "error", summary: "", detail: response.data.mensaje, life: 20000 });
                    } else {
                        this.growl.show({ severity: "success", summary: "", detail: response.data.mensaje, life: 20000 });
                        this.resetEstados();
                    }
                }).catch((e) => {
                    //JILG760727MOCMSL08
                    this.growl.show({ severity: "error", summary: "", detail: e });
                });
        }
    }

    validarFormulario = (usuario) => {
        const errores = {};
        var expReg = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
        var validacionCurp = expReg.exec(usuario.usuario);

        if (!usuario.usuario)
            errores.usuario = "El usuario (CURP) es requerido";
        if (!validacionCurp)
            errores.usuario = "El usuario no es valido"

        let { tokenCaptcha } = this.state;
        if (servicioObjetos.esObjetoVacio(tokenCaptcha))
            errores.captcha = 'Debe de resolver el captcha';
        return errores;
    }

    mostrarModal = () => {
        this.setState({ mostralModal: true, usuario: {}, errores: {} });
    };

    resetEstados = () => {
        this.setState({ mostralModal: false });
    }

    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    respuestaCaptcha = (response) => {
        this.setState({
            tokenCaptcha: response.response
        });
    }

    expireCaptcha = () => {
        this.setState({ tokenCaptcha: null });
        this.captcha.reset();
    }

    render() {

        let { errores, usuario } = this.state;

        const pieDialogo = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button icon='pi pi-save' label="Enviar contraseña" onClick={this.recuperarContrasena} style={{ marginRight: '20px' }} />
                <Button className='p-button-danger' icon='pi pi-times-circle' label="Cancelar" onClick={this.resetEstados} style={{ marginRight: '20px' }} />
            </div>
        );

        return (<div>

            <Growl ref={(el) => this.growl = el} />

            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-12">
                    <button class="p-button p-component p-button-text-icon-left" onClick={this.mostrarModal}>
                        <span class="pi pi-refresh p-c p-button-icon-left" />
                        <span class="p-button-text p-c">Recuperar contraseña</span>
                    </button>
                </div>
            </div>

            <Dialog header="¿Olvidó su contraseña?" visible={this.state.mostralModal} modal={true} style={{ width: '50vw' }} footer={pieDialogo} onHide={this.resetEstados} >
                <div style={{ margin: '1.5rem 2rem 2rem 2rem', textAlign: 'justify' }}>
                    <p>Escriba su dirección de correo electrónico. Si la dirección existe en nuestro registro, le enviaremos su nombre de usuario y una contraseña nueva.</p>
                    <p>Como las contraseñas se almacenan de una forma codificada, no podemos saber su contraseña original, ni nadie mas puede hacerlo, por esta razón se generará una nueva contraseña para su cuenta.</p>
                </div>

                <h4 style={{ margin: '0 2rem 1.5rem 2rem' }}>Los siguientes datos son requeridos: </h4>

                <div className="p-grid p-fluid" style={{ display: 'flex', justifyContent: 'center', margin: '1rem 2rem 1rem 2rem' }}>

                    <div className="p-col-12 p-md-12" >
                        <InputText placeholder="Usuario (CURP)" className={errores.usuario ? 'p-error ' : ''} onChange={(e) => { this.asignarValores(e, true) }} id="usuario.usuario" name="usuario.usuario"
                            value={usuario.usuario || ''} />
                        {errores.usuario ? <div> <Message severity="error" text={errores.usuario} /> </div> : null}
                    </div>

                    <div className="p-col-12 p-md-9" style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                        <Captcha ref={(r) => this.captcha = r} theme="dark" siteKey="6LfFYG0UAAAAAJsylLTvKIbfdDpgiWPUIP0acdEB" onResponse={this.respuestaCaptcha} onExpire={this.expireCaptcha} language="es"></Captcha>
                        {errores.captcha ? <div><Message severity="error" text={errores.captcha} /> </div> : null}
                    </div>

                </div>

            </Dialog>

        </div>);
    }
}